module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAINJREFUWEftllEKgDAMQ9ub6cnEk+nN4k8HIoPWfqzKst+xNX3NWFSKlxbXFwr4LwEAi4hs5qFdVc+Mn9IETMBhRdf5BGRw9868HgGAhv1+3zgPAECnk3EeKBfQuucrIAESIAESmI/Ao2MvDoR/x3Ae+IqAFkI9AuGAEibgVczuUwAJXLNOaSHARqwzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/xinxi.png
// module id = 5Fq1
// module chunks = 1